import { defineStore } from 'pinia'
import Cookies from 'js-cookie'

export const RouterHandler = defineStore('current_route', {
    state: () => {
        return { current_route: Cookies.get('current_route') ? Cookies.get('current_route') : null }
    },
    actions: {
        get() {
            return this.current_route
        },
        set(value) {
            Cookies.set('current_route', value)
            this.current_route = Cookies.get('current_route')
        }
    },
})